import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { Band } from './band';
import { defaultUnknown } from './ordinal';
/**
 * Point 比例尺
 *
 * 一种特殊的 band scale，它的 bandWidth 恒为 0。
 *
 * 由于部分选项较为抽象，见下图描述：
 *
 * PO = Padding = PaddingInner
 * domain =  ["A", "B", "C"]
 *
 * |<------------------------------------------- range ------------------------------------------->|
 * |             |                                 |                                 |             |
 * |<--step*PO-->|<--------------step------------->|<--------------step------------->|<--step*PO-->|
 * |             |                                 |                                 |             |
 * |             A                                 B                                 C             |
 * |-----------------------------------------------------------------------------------------------|
 *
 * 性能方便较 d3 快出 8 - 9 倍
 */
export var Point = /*#__PURE__*/function (_Band) {
  _inherits(Point, _Band);
  _createClass(Point, [{
    key: "getDefaultOptions",
    // 覆盖默认配置
    value: function getDefaultOptions() {
      return {
        domain: [],
        range: [0, 1],
        align: 0.5,
        round: false,
        padding: 0,
        unknown: defaultUnknown,
        paddingInner: 1,
        paddingOuter: 0
      };
    } // 能接受的参数只是 PointOptions，不能有 paddingInner 这些属性
  }]);
  function Point(options) {
    _classCallCheck(this, Point);
    return _possibleConstructorReturn(this, _getPrototypeOf(Point).call(this, options));
  }
  // Point 的 paddingInner 只能是1，不能被覆盖
  _createClass(Point, [{
    key: "getPaddingInner",
    value: function getPaddingInner() {
      return 1;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Point(this.options);
    }
  }, {
    key: "update",
    value: function update(options) {
      _superPropGet(Point, "update", this, 3)([options]);
    }
  }, {
    key: "getPaddingOuter",
    value: function getPaddingOuter() {
      return this.options.padding;
    }
  }]);
  return Point;
}(Band);